export enum VehicleMaintenanceStates {
    PREDICTED = 'PREDICTED',
    PERFORM = 'PERFORM',
    //OBLIGATORY = 'OBLIGATORY'
}
